import { createAction } from '@reduxjs/toolkit';

import { apiCheckNgWords } from 'mastodon/api/ng_words';
import { createAppThunk } from 'mastodon/store/typed_functions';

import { openModal } from './modal';

// The text the author was already warned about. Closing the warning and
// pressing the button again sends it; changing the text checks again.
let acknowledgedText: string | null = null;

export const resetNgWordsWarning = () => {
  acknowledgedText = null;
};

/** Keeps the post button busy while the NG word check runs */
export const setComposeCheckingNgWords = createAction<boolean>(
  'compose/checkingNgWords',
);

/**
 * Before posting, checks whether the text contains NG words of someone it
 * mentions. If so, shows a warning instead of posting; otherwise (or when
 * the check fails) calls `proceed`.
 */
export const checkNgWordsBeforeSubmit = createAppThunk(
  async (proceed: () => void, { dispatch, getState }) => {
    const compose = getState().compose;

    // Already checking or posting (e.g. the button was pressed twice)
    if (compose.get('is_submitting')) return;

    const status = (compose.get('text') as string | null) ?? '';
    const spoilerText = compose.get('spoiler')
      ? ((compose.get('spoiler_text') as string | null) ?? '')
      : '';
    const key = `${spoilerText}\n${status}`;

    if (!key.includes('@') || key === acknowledgedText) {
      proceed();
      return;
    }

    dispatch(setComposeCheckingNgWords(true));

    try {
      const { warnings } = await apiCheckNgWords({
        status,
        spoiler_text: spoilerText,
      });

      dispatch(setComposeCheckingNgWords(false));

      if (warnings.length === 0) {
        proceed();
        return;
      }

      acknowledgedText = key;
      dispatch(
        openModal({ modalType: 'NG_WORDS_WARNING', modalProps: { warnings } }),
      );
    } catch {
      dispatch(setComposeCheckingNgWords(false));
      // Never keep someone from posting because the check failed
      proceed();
    }
  },
);
